import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getPrices = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/pricing`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching prices:', error);
    return [];
  }
};

export const getPriceByFrameType = async (frameType) => {
  try {
    const response = await axios.get(`${BASE_URL}/pricing/${frameType}`);
    return response.data.data.price;
  } catch (error) {
    console.error(`Error fetching price for ${frameType}:`, error);
    return 49; // Default to 49 if API call fails
  }
};
